function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.55 13.02 13.23 3.7c-.1-.1-.23-.19-.36-.24a1.07 1.07 0 0 0-.43-.09H3.75c-.1 0-.19.04-.27.11-.07.07-.11.17-.11.27v8.69c0 .15.03.29.09.43s.14.26.24.36l9.31 9.31c.1.1.23.19.37.24a1.07 1.07 0 0 0 .86 0c.14-.06.26-.14.37-.24l7.94-7.94c.1-.1.19-.23.24-.37a1.07 1.07 0 0 0 0-.86c-.06-.14-.14-.26-.24-.37Zm-.53 1.06-7.94 7.94c-.07.07-.17.11-.26.11s-.19-.04-.26-.11L4.23 12.7a.381.381 0 0 1-.11-.26V4.12h8.31c.1 0 .19.04.26.11L22 13.54c.07.07.11.17.11.26s-.04.19-.11.26ZM8.63 7.88c0 .15-.04.29-.13.42-.08.12-.2.22-.34.28a.71.71 0 0 1-.43.04.685.685 0 0 1-.38-.21c-.1-.1-.18-.24-.21-.38-.03-.15-.01-.3.04-.43a.77.77 0 0 1 .7-.47.75.75 0 0 1 .75.75Z",
    style: {
      strokeWidth: 0
    }
  }));
};
export default SvgTag;